import React, { createContext, useContext } from "react";
import { useNavigate, useLocation } from "react-router";
import type { ReactNode } from "react";

export type Page =
  | "vendite"
  | "spedizioni"
  | "impostazioni"
  | "dashboard"
  | "settings";

interface RouterContextType {
  currentPage: Page;
  navigateTo: (page: Page) => void;
}

const RouterContext = createContext<RouterContextType | undefined>(undefined);

export const useRouter = () => {
  const context = useContext(RouterContext);
  if (!context) {
    throw new Error("useRouter must be used within a RouterProvider");
  }
  return context;
};

interface RouterProviderProps {
  children: ReactNode;
}

export const RouterProvider: React.FC<RouterProviderProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Mappa i percorsi URL alle pagine
  const pathToPage: Record<string, Page> = {
    "/": "vendite",
    "/vendite": "vendite",
    "/spedizioni": "spedizioni",
    "/impostazioni": "impostazioni",
    "/settings": "impostazioni",
  };

  // Mappa le pagine ai percorsi URL
  const pageToPath: Record<Page, string> = {
    vendite: "/vendite",
    spedizioni: "/spedizioni",
    impostazioni: "/impostazioni",
    dashboard: "/vendite",
    settings: "/impostazioni",
  };

  const currentPage = pathToPage[location.pathname] || "dashboard";

  const navigateTo = (page: Page) => {
    navigate(pageToPath[page]);
  };

  return (
    <RouterContext.Provider value={{ currentPage, navigateTo }}>
      {children}
    </RouterContext.Provider>
  );
};

export default RouterProvider;
